import { useState } from "react";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import { generateInvoiceFile } from "~/modules/billing/api/processedInvoice/processedInvoiceApiDispatchers.ts";

export const useInvoiceDownload = (invoiceId: string) => {
	const [isGenerating, setIsGenerating] = useState(false);

	const handleDownload = async () => {
		if (isGenerating) return;

		setIsGenerating(true);
		try {
			const response = await generateInvoiceFile(invoiceId);
			const fileInfo = getDataFromResponse(response);
			// Auto-download the file
			const link = document.createElement('a');
			link.href = fileInfo.downloadUrl;
			link.download = fileInfo.fileName;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);

		} catch (error) {
			console.log(error);
		} finally {
			setIsGenerating(false);
		}
	};

	return {
		handleDownload,
		isGenerating
	};
};